const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import RankItem from "./rankItem";
import UserDataManager from "../../../../manager/user_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import Rank from "./rank";
import RankHead from "./rankHead";
import ModelData from "../../../public/model_data";

@ccclass
export default abstract class MiniRankCompent extends ViewBase {

    @property(cc.Sprite)
    miniHeads:cc.Sprite[] = []

    @property(cc.Node)
    showMaxRankBtn:cc.Node = null

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    m_list: ListView = null

    curShowType = 1
    rankDataByType = []

    onLoad(){
        let self = this
        this.showMaxRankBtn.on("click", ()=>{
            self.rankDataByType = []
            self.getRankDataByType(1, ()=>{
                ModuleManager.instance.showModule(Rank, self.rankDataByType)
            })
        }, this)
        this.schedule(()=>{
            self.getRankDataByType(self.curShowType)
        }, 600, cc.macro.REPEAT_FOREVER, 0)
        self.getRankDataByType(this.curShowType)

        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 1,
            gap_y: 20,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }

    //获取财富排行榜数据  
    //@param 1-财富榜,2-赢金排行榜
    getRankDataByType(rankType, callBack = null){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "rank/getRank?",
            params: {
                rankType: rankType,
                gameUserId:ModelData.instance.roleData.id,
            },
        }
        this.apiHttpGet(requestData, (respone) => {
            self.rankDataByType[rankType] = respone.data
            if (rankType == 1){
                self.updateShow(respone.data.rankItems)
            }
            if (callBack != null){
                callBack()
            }
        })
    }

    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }


    updateShow(m_Data:any = null){
        if (m_Data == null){ 
            m_Data = []
         }
        this.m_list.resize()
        this.m_list.set_data(m_Data);
        this.m_list.select_item(1)
        this.m_list.scroll_to(0)
        
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let _recordItem = item.getComponent(RankHead)
        _recordItem.setData(data,index, this)
    }
}